import type React from 'react';

import { Control } from '@vlabs/uikit';

import st from './ViewRow.module.sass';

interface ViewRowProps {
  label?: React.ReactNode;
  children?: React.ReactNode;
}

function ViewRow({
  label = undefined,
  children = undefined,
}: ViewRowProps): React.JSX.Element {
  return (
    <div className={st.Row}>
      <span className={st.Label}>{label ?? ''}</span>
      <span className={st.Value}>{children}</span>
    </div>
  );
}

interface ViewRowTitleProps {
  label: React.ReactNode;
  children?: React.ReactNode;
}

/** Заголовочная строка карточки: label 16px medium. */
function ViewRowTitle({
  label,
  children = undefined,
}: ViewRowTitleProps): React.JSX.Element {
  return (
    <div className={st.Row}>
      <span className={st.LabelTitle}>{label}</span>
      <span className={st.ValueTitle}>{children}</span>
    </div>
  );
}

interface ViewRowSectionProps {
  label: React.ReactNode;
}

/** Строка-раздел внутри карточки: label 14px medium без значения. */
function ViewRowSection({ label }: ViewRowSectionProps): React.JSX.Element {
  return (
    <div className={st.Row}>
      <span className={st.LabelSection}>{label}</span>
    </div>
  );
}

interface ViewRowCheckboxProps {
  label: React.ReactNode;
  checked: boolean;
}

function ViewRowCheckbox({
  label,
  checked,
}: ViewRowCheckboxProps): React.JSX.Element {
  return (
    <ViewRow label={label}>
      <Control.Checkbox
        checked={checked}
        disabled
      />
    </ViewRow>
  );
}

export {
  ViewRow, ViewRowCheckbox, ViewRowSection, ViewRowTitle,
};
